import React from 'react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="pt-12 pb-16 px-4 md:pt-20 md:pb-24 bg-white text-center" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="inline-block bg-brand-yellow text-black font-bold px-4 py-1 rounded-full text-sm md:text-base mb-6 uppercase tracking-wider border-2 border-black" data-id="element-76">
          Atención Freelancers y Profesionales Digitales
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-8" data-id="element-77">
          De Freelancer Agotado a Arquitecto de Sistemas:{' '}
          <span className="text-brand-red" data-id="element-78">
            Domina n8n y vende automatizaciones de alto valor.
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-8" data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/bMZXbL9woM8ELc9vJmPUQi/Domina_la_automatizacion_y_la_IA.png" alt="La Saga del Arquitecto No-Code" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl border-4 border-gray-100" data-id="element-80" />
        </a>

        <p className="text-xl md:text-2xl text-gray-700 font-medium mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-81">
          La metodología definitiva para construir flujos inteligentes con IA y
          crear un negocio de servicios recurrentes,{' '}
          <span className="font-bold underline decoration-brand-red decoration-4 underline-offset-4" data-id="element-82">
            sin escribir una sola línea de código.
          </span>
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-83">
          <Button href="#compra" className="animate-bounce-slow" data-id="element-84">
            Quiero empezar a automatizar ahora
          </Button>
          <p className="text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-85">
            <span className="flex h-3 w-3 relative" data-id="element-86">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-87"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-88"></span>
            </span>
            Oferta de lanzamiento disponible hoy
          </p>
        </div>
      </div>
    </section>;
}